export default function DeliveryIcon({ className = '' }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 10.8333L17.5 6.66667L13.3333 2.5M17.5 6.66667H7.5C6.39493 6.66667 5.33512 7.10565 4.55372 7.88706C3.77232 8.66846 3.33333 9.72826 3.33333 10.8333C3.33333 11.9384 3.77232 12.9982 4.55372 13.7796C5.33512 14.561 6.39493 15 7.5 15H8.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

